import React from 'react';
import { Stack } from '@fluentui/react';
import clsx from 'clsx';
import { IStyledComponent } from 'common/Common.types';
import { IAppEffects } from 'common/theme/AppTheme';

import { useCardStyles } from './Card.styles';

interface ICardProps extends IStyledComponent {
  depth?: keyof IAppEffects;
  width?: number | string;
  maxWidth?: number | string;
  minWidth?: number | string;
  children?: React.ReactNode;
}

export const Card = (props: ICardProps) => {
  const { className, styles, depth, width, minWidth, maxWidth, children } = props;
  const classNames = useCardStyles(depth, width, maxWidth, minWidth);

  return (
    <Stack as="section" className={clsx(className, classNames.root)} styles={styles}>
      {children}
    </Stack>
  );
};
